import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const updateCheckPlugin = createPlugin({
  id: 'update-check',
  routes: {
    root: rootRouteRef,
  },
});

export const UpdateCheckPage = updateCheckPlugin.provide(
  createRoutableExtension({
    name: 'UpdateCheckPage',
    component: () =>
      import('./pages/update-check/UpdateCheckPage.tsx').then(
        m => m.UpdateCheckPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const UpdateCheckAnalysisPage = updateCheckPlugin.provide(
  createRoutableExtension({
    name: 'UpdateCheckPage',
    component: () =>
      import('./pages/update-check-analysis/UpdateCheckAnalysisPage').then(
        m => m.UpdateCheckAnalysisPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
